import TypeOfWaste from './containers/TypeOfWaste';

export default TypeOfWaste;
